import type { components } from "@/api-schema";
import type { FilterOption } from "../../_types";

export const BRAND_DAT_ID_NOT_SET = "IS_NULL";

export function buildBrandDatIdFilterOptions(
  brands: readonly Pick<components["schemas"]["Brand"], "datId">[] = [],
  selectedValues: readonly string[] = [],
): FilterOption[] {
  const datIds = new Set([...brands.map((brand) => brand.datId), ...selectedValues]);

  return [
    { id: BRAND_DAT_ID_NOT_SET, name: "common:NotSet" },
    ...Array.from(datIds)
      .filter((datId): datId is string => !!datId?.trim() && datId !== BRAND_DAT_ID_NOT_SET)
      .map((datId) => ({ id: datId, name: datId })),
  ];
}
